<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <template v-if="loading">
          <pulse-loader :loading="true" :color="loadingColor" class="text-center"/>
        </template>
        <template v-else>
          <div>
            <table class="table table-sm">
              <thead>
              <tr>
                <th>№</th>
                <th>Имя</th>
                <th>Телефон</th>
                <th>Лимит</th>
              </tr>
              </thead>
              <draggable v-model="records" v-if="records && records.length" tag="tbody">
                <tr v-for="record in records" :key="record.id">
                  <td>{{ record.order_num }} <i class="icon-fa icon-fa-arrows pointer"></i></td>
                  <td>{{ record.name }}</td>
                  <td>{{ record.phone }}</td>
                  <td>{{ record.sum_limit }}</td>
                </tr>
              </draggable>
            </table>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api'
// import draggable from "@/vuedraggable";
import VueLadda from 'vue-ladda/src/vue-ladda.vue'
import draggable from 'vuedraggable'

export default {
  components: {
    VueLadda,
    draggable,
  },
  data() {
    return {
      loadingColor: this.$constants.LOADING_COLOR,
      loading: false,
      records: []
    }
  },
  mounted() {
    this.getSenders();
  },
  methods: {
    async getSenders() {
      this.loading = true;
      const {data} = await api.index('/cod/senders');
      if (data.success) {
        this.records = data.records;
      } else {
        toastr["warning"](data.message || "Ошибка сервера");
      }
      this.loading = false;
    }
  }
}
</script>
